
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9.012","height":"6.214"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 25853","d":"M.53 2.58l2.949 2.949c.014.014 5-5 5-5","fill":"none","stroke":"#fff","stroke-width":"1.5"}})])
          )
        }
      }
    